import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "appointment";

const GET_ALL_APPOINTMENT_URL = `${prefix}/all`;
const UPDATE_APPOINTMENT_BY_ID_URL = `${prefix}/update-by-id`;
const GET_DOCTOR_DETAIL_URL = `${prefix}/get-doctor-detail`;

/**
 * @func getAllAppointment
 * @desc get all appointment data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} appointment array
 */
export const getAllAppointment = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_APPOINTMENT_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllAppointment");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllAppointment */

/**
 * @func updateAppointmentById
 * @desc update appointment by id
 * @author izeberg
 * @param {number} id - appointment id
 * @param {Object} body - update appointment body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateAppointmentById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_APPOINTMENT_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateAppointmentById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateAppointmentById */

/**
 * @func getDoctorDetail
 * @desc get all appointment data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} appointment array
 */
export const getDoctorDetail = async signal => {
    try {
        const { data, status } = await axios.get(GET_DOCTOR_DETAIL_URL, {
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getDoctorDetail");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getDoctorDetail */
